import React, { useState } from 'react'
import './ProjectDetails.scss'
const ProjectDetails = ({projectDetails}) => {
  
  const { images, name, description, live, client, server, frontend,backend, tools } = projectDetails || {}
  const [currentImage, setCurrentImage] = useState(images[0]);
  const selectImage = (image) => {
    setCurrentImage(image);
  };
  console.log(frontend)
  return (
    <div className="grid lg:grid-cols-12">
      {/* Images Section  */}
      <div className="lg:col-span-5 lg:mr-10">
        <div className="grid lg:grid-cols-12">
          {/* main Image  */}
          <div className="lg:h-[800px] h-[500px] border-4 mb-5  overflow-y-scroll lg:col-span-9 img-scrollbar">
            <img className="w-full" src={currentImage} alt="" />
          </div>
          {/* Image Button  */}
          <div className="lg:col-span-3">
            <div className="lg:h-[800px] md:h-[300px] sm:h-[250px]  h-[200px] grid md:grid-cols-6 sm:grid-cols-4 grid-cols-4 grid-rows-2 gap-x-2 gap-y-2 lg:ml-4 lg:grid-rows-6 lg:grid-cols-1">
              {images?.map((image, index) => (
                <div
                  onClick={() => selectImage(image)}
                  className={`border-4 h-full lg:ml-2 cursor-pointer hover:scale-110 ease-in duration-500 hover:border-green-400 ${
                    currentImage === image
                      ? "border-purple-500"
                      : "border-white"
                  }`}
                >
                  <img className="w-full h-full " src={image} alt="" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Project Details  */}
      {/* Project Details  */}
      {/* Project Details  */}
      <div className="lg:col-span-7 ml-5 mt-10 lg:mt-0 glass p-5">
        {/* link  */}
        <div className="flex justify-between items-center pb-4">
          <a
            className="tech-glass px-1 md:px-3 lg:px-3 py-1 ring-1 ring-emerald-500 rounded-md hover:text-emerald-100 text-sm md:text-lg lg:text-lg font-bold"
            target="_blank"
            href={live}
          >
            <button>Live Side</button>
          </a>

          <a
            className="tech-glass px-1 md:px-3 lg:px-3 py-1 ring-1 ring-emerald-500 rounded-md hover:text-emerald-100 text-sm md:text-lg lg:text-lg font-bold"
            target="_blank"
            href={client}
          >
            <button>Client Side</button>
          </a>

          <a
            className="tech-glass px-1 md:px-3 lg:px-3 py-1 ring-1 ring-emerald-500 rounded-md hover:text-emerald-100 text-sm md:text-lg lg:text-lg font-bold"
            target="_blank"
            href={server}
          >
            <button>Server Code</button>
          </a>
        </div>
        {/* Titel & Description */}
        <div className="space-y-5 mt-5 lg:mt-0">
          <h1 className="text-4xl text-emerald-50 font-extrabold">{name}</h1>
          <p className=" text-emerald-50">
            <span className="f font-bold text-lg">Description :</span>{" "}
            <p className="hover:text-emerald-400 ease-in duration-100">
              {description}
            </p>
          </p>
          <h1 className="text-lg  text-emerald-50 font-bold">Technology</h1>

          <div>
            <h6 className="font font-extrabold">Frontend:</h6>
            <div className="flex items-center flex-wrap">
              {frontend?.map((item, index) => (
                <p className="ring-1 tech-glass rounded-sm px-2 m-1 text-emerald-50 hover:text-emerald-400 ease-in duration-100">
                  {item}
                </p>
              ))}
            </div>
          </div>
          <div>
            <h6 className="font font-extrabold">Backend:</h6>
            <div className="flex items-center flex-wrap">
              {backend?.map((item, index) => (
                <p className="ring-1 tech-glass rounded-sm px-2 m-1 text-emerald-50 hover:text-emerald-400 ease-in duration-100">
                  {item}
                </p>
              ))}
            </div>
          </div>
          <div>
            <h6 className="font font-extrabold">Tools:</h6>
            <div className="flex items-center flex-wrap">
              {tools?.map((item, index) => (
                <p className="ring-1 tech-glass rounded-sm px-2 m-1 text-emerald-50 hover:text-emerald-400 ease-in duration-100">
                  {item}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectDetails